export default "__VITE_ASSET__d6f6d79c__"